import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useDueDatesApi } from "../../http/dueDates/api";
import ModalDialog from "../ui/ModalDialog";

type SetSettledDueDatesDialogProps = {
  dueDates: {
    id: string;
    carId: string;
  }[];
  onClose: (success?: boolean) => void;
};

const SetSettledDueDatesDialog: FC<SetSettledDueDatesDialogProps> = ({ dueDates, onClose }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const dueDatesApi = useDueDatesApi();
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.dueDates.setSettledSelected}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,
          onClick: () => {
            setIsSubmitting(true);
            const dueDateIds = dueDates.map((d) => d.id);
            const carIds = dueDates.map((d) => d.carId);
            dueDatesApi
              .bulkSettleDueDates({ dueDateIds }, carIds)
              .then(() => {
                onClose(true);
                dispatch(showSuccessNotification(i18n.t));
              })
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.dueDates.questions.setSettled}
    </ModalDialog>
  );
};

export default SetSettledDueDatesDialog;
